import * as React from "react";
import { AppLayoutType } from "kw/components/AppLayout/AppLayout";
import { ClaimFlowPage } from "kw/claims/pages/ClaimFlowPage";
import { ClaimsErrorPage } from "./pages/ClaimsErrorPage";
import { ClaimSubmissionSuccessPage } from "./pages/ClaimSubmissionSuccessPage";
import { ClaimSummaryPage } from "./pages/ClaimSummaryPage";
import { IntroPage } from "./pages/IntroPage";
import { Router } from "@reach/router";
import { RouterOutlet } from "kw/components/RouterOutlet/RouterOutlet";
import { SelectPolicyPage } from "./pages/SelectPolicyPage";
import { ClaimListingPage } from "./pages/ClaimListingPage";
import { ClaimDetailsPage } from "./pages/ClaimDetailsPage";
import { Error404Page } from "kw/quoting/pages/Error404Page";

export function ClaimsMain() {
  return (
    <Router basepath="/claims">
      <Error404Page default />
      <RouterOutlet
        component={ClaimListingPage}
        path="/"
        layoutOverrides={{
          showHeader: true,
          headerText: "Claims",
          hideBackButton: true,
          layoutType: AppLayoutType.Portal,
          headerTextCenter: false,
        }}
      />
      <RouterOutlet
        component={ClaimDetailsPage}
        path="/:claimId"
        layoutOverrides={{
          showHeader: false,
          hideBackButton: true,
          layoutType: AppLayoutType.Portal,
        }}
      />
      <RouterOutlet
        component={SelectPolicyPage}
        path="/make-a-claim"
        layoutOverrides={{
          showHeader: true,
          headerText: "Make a claim",
          layoutType: AppLayoutType.Portal,
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={IntroPage}
        path="/make-a-claim/:policyId/intro"
        layoutOverrides={{
          showHeader: true,
          headerText: "Make a claim",
          layoutType: AppLayoutType.Portal,
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={ClaimFlowPage}
        path="/make-a-claim/:policyId/details/*"
      />
      <RouterOutlet
        component={ClaimSummaryPage}
        path="/make-a-claim/:policyId/summary"
        layoutOverrides={{
          layoutType: AppLayoutType.Progress,
          showHeader: false,
          hideBackButton: true,
        }}
      />
      <RouterOutlet
        component={ClaimSubmissionSuccessPage}
        path="/make-a-claim/:policyId/success"
        layoutOverrides={{
          showHeader: false,
          hideBackButton: true,
          layoutType: AppLayoutType.Portal,
        }}
      />
      <RouterOutlet
        component={ClaimsErrorPage}
        path="/make-a-claim/error"
        layoutOverrides={{
          showHeader: true,
          headerText: "Claims",
          headerTextCenter: true,
          layoutType: AppLayoutType.Portal,
        }}
      />
    </Router>
  );
}
